import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { api } from '../api/client';
import type { Post } from '../types/api';

const Posts: React.FC = () => {
  const auth = useAuth();
  const token = auth.user?.access_token;
  const [items, setItems] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.posts.list({ limit: 30 }, token)
      .then((r) => setItems(r.items))
      .catch((e) => setError(e instanceof Error ? e.message : 'Failed to load'))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div style={{ padding: '24px', color: '#9ca3af' }}>Loading posts…</div>;
  if (error) return <div style={{ padding: '24px', color: '#dc2626' }}>{error}</div>;

  return (
    <div style={{ padding: '24px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ color: '#fff', marginBottom: '16px' }}>Posts</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {items.map((post) => (
          <Link
            key={post.postId}
            to={`/posts/${post.postId}`}
            style={{
              display: 'block',
              padding: '16px',
              border: '1px solid #374151',
              borderRadius: '8px',
              backgroundColor: '#1f2937',
              color: '#fff',
              textDecoration: 'none',
            }}
          >
            <span style={{ fontSize: '12px', color: '#4ade80', textTransform: 'uppercase' }}>{post.type}</span>
            <h2 style={{ fontSize: '1.1rem', marginTop: '4px' }}>{post.title}</h2>
            <p style={{ fontSize: '14px', color: '#9ca3af', marginTop: '4px' }}>
              {post.authorDisplayName || post.authorId} · {post.commentCount ?? 0} comments
            </p>
          </Link>
        ))}
      </div>
      {items.length === 0 && <p style={{ color: '#9ca3af' }}>No posts yet.</p>}
    </div>
  );
};

export default Posts;
